(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sub-collection-acc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var carouselStates = {};

  function getVisibleCount(viewportWidth) {
    if (viewportWidth <= 600) return 1;
    if (viewportWidth <= 992) return 2;
    return 3;
  }

  function getState(trackId) {
    if (!carouselStates[trackId]) {
      carouselStates[trackId] = { currentIndex: 0 };
    }
    return carouselStates[trackId];
  }

  function setSlideSizes(track, slides, slideWidth) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.width = slideWidth + 'px';
      slides[i].style.flex  = '0 0 ' + slideWidth + 'px';
    }
  }

  function updateCarousel(trackId) {
    var track = document.getElementById(trackId);
    if (!track) return;

    var viewport = track.parentElement;
    if (!viewport) return;

    var slides = track.querySelectorAll('.sub4-slide');
    var total  = slides.length;
    if (!total) return;

    var gap = 12; /* must match the CSS gap value */
    var viewportWidth = viewport.offsetWidth;
    var visible   = getVisibleCount(viewportWidth);
    /* Subtract gaps between visible slides from available width */
    var slideWidth = Math.floor((viewportWidth - gap * (visible - 1)) / visible);
    var maxIndex   = Math.max(0, total - visible);

    /* Apply pixel width to every slide so they never shrink/grow */
    setSlideSizes(track, slides, slideWidth);

    var state = getState(trackId);
    if (state.currentIndex < 0) state.currentIndex = 0;
    if (state.currentIndex > maxIndex) state.currentIndex = maxIndex;

    /* Pixel-perfect translateX — account for gap between slides */
    var offset = state.currentIndex * (slideWidth + gap);
    track.style.transform = 'translateX(-' + offset + 'px)';

    /* Update arrow disabled state */
    var wrapper = track.closest('.sub4-carousel-wrapper');
    if (wrapper) {
      var leftBtn  = wrapper.querySelector('.sub4-arrow--left');
      var rightBtn = wrapper.querySelector('.sub4-arrow--right');
      if (leftBtn)  leftBtn.disabled  = (state.currentIndex <= 0);
      if (rightBtn) rightBtn.disabled = (state.currentIndex >= maxIndex);
    }
  }

  window.sub4Prev = function (trackId) {
    var state = getState(trackId);
    state.currentIndex = Math.max(0, state.currentIndex - 1);
    updateCarousel(trackId);
  };

  window.sub4Next = function (trackId) {
    var track = document.getElementById(trackId);
    if (!track) return;
    var viewport = track.parentElement;
    if (!viewport) return;
    var slides = track.querySelectorAll('.sub4-slide');
    var total  = slides.length;
    var visible  = getVisibleCount(viewport.offsetWidth);
    var maxIndex = Math.max(0, total - visible);
    var state = getState(trackId);
    state.currentIndex = Math.min(maxIndex, state.currentIndex + 1);
    updateCarousel(trackId);
  };

  function initCarousels() {
    document.querySelectorAll('.sub4-carousel-track').forEach(function (track) {
      updateCarousel(track.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.sub4-carousel-track').forEach(function (track) {
        updateCarousel(track.id);
      });
    }, 120);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-collection-ridas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var carouselStates = {};

  function getVisibleCount(viewportWidth) {
    if (viewportWidth <= 600) return 1;
    if (viewportWidth <= 992) return 2;
    return 3;
  }

  function getState(trackId) {
    if (!carouselStates[trackId]) {
      carouselStates[trackId] = { currentIndex: 0 };
    }
    return carouselStates[trackId];
  }

  function setSlideSizes(track, slides, slideWidth) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.width = slideWidth + 'px';
      slides[i].style.flex  = '0 0 ' + slideWidth + 'px';
    }
  }

  function updateCarousel(trackId) {
    var track = document.getElementById(trackId);
    if (!track) return;

    var viewport = track.parentElement;
    if (!viewport) return;

    var slides = track.querySelectorAll('.sub4-slide');
    var total  = slides.length;
    if (!total) return;

    var gap = 12; /* must match the CSS gap value */
    var viewportWidth = viewport.offsetWidth;
    var visible   = getVisibleCount(viewportWidth);
    /* Subtract gaps between visible slides from available width */
    var slideWidth = Math.floor((viewportWidth - gap * (visible - 1)) / visible);
    var maxIndex   = Math.max(0, total - visible);

    /* Apply pixel width to every slide so they never shrink/grow */
    setSlideSizes(track, slides, slideWidth);

    var state = getState(trackId);
    if (state.currentIndex < 0) state.currentIndex = 0;
    if (state.currentIndex > maxIndex) state.currentIndex = maxIndex;

    /* Pixel-perfect translateX — account for gap between slides */
    var offset = state.currentIndex * (slideWidth + gap);
    track.style.transform = 'translateX(-' + offset + 'px)';

    /* Update arrow disabled state */
    var wrapper = track.closest('.sub4-carousel-wrapper');
    if (wrapper) {
      var leftBtn  = wrapper.querySelector('.sub4-arrow--left');
      var rightBtn = wrapper.querySelector('.sub4-arrow--right');
      if (leftBtn)  leftBtn.disabled  = (state.currentIndex <= 0);
      if (rightBtn) rightBtn.disabled = (state.currentIndex >= maxIndex);
    }
  }

  window.sub4Prev = function (trackId) {
    var state = getState(trackId);
    state.currentIndex = Math.max(0, state.currentIndex - 1);
    updateCarousel(trackId);
  };

  window.sub4Next = function (trackId) {
    var track = document.getElementById(trackId);
    if (!track) return;
    var viewport = track.parentElement;
    if (!viewport) return;
    var slides = track.querySelectorAll('.sub4-slide');
    var total  = slides.length;
    var visible  = getVisibleCount(viewport.offsetWidth);
    var maxIndex = Math.max(0, total - visible);
    var state = getState(trackId);
    state.currentIndex = Math.min(maxIndex, state.currentIndex + 1);
    updateCarousel(trackId);
  };

  function initCarousels() {
    document.querySelectorAll('.sub4-carousel-track').forEach(function (track) {
      updateCarousel(track.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.sub4-carousel-track').forEach(function (track) {
        updateCarousel(track.id);
      });
    }, 120);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-collection-tshirts"] && !Shopify.designMode) return;
  try {
    
(function () {
  var carouselStates = {};

  function getVisibleCount(viewportWidth) {
    if (viewportWidth <= 600) return 1;
    if (viewportWidth <= 992) return 2;
    return 3;
  }

  function getState(trackId) {
    if (!carouselStates[trackId]) {
      carouselStates[trackId] = { currentIndex: 0 };
    }
    return carouselStates[trackId];
  }

  function setSlideSizes(track, slides, slideWidth) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.width = slideWidth + 'px';
      slides[i].style.flex  = '0 0 ' + slideWidth + 'px';
    }
  }

  function updateCarousel(trackId) {
    var track = document.getElementById(trackId);
    if (!track) return;

    var viewport = track.parentElement;
    if (!viewport) return;

    var slides = track.querySelectorAll('.sub4-slide');
    var total  = slides.length;
    if (!total) return;

    var gap = 12; /* must match the CSS gap value */
    var viewportWidth = viewport.offsetWidth;
    var visible   = getVisibleCount(viewportWidth);
    /* Subtract gaps between visible slides from available width */
    var slideWidth = Math.floor((viewportWidth - gap * (visible - 1)) / visible);
    var maxIndex   = Math.max(0, total - visible);

    /* Apply pixel width to every slide so they never shrink/grow */
    setSlideSizes(track, slides, slideWidth);

    var state = getState(trackId);
    if (state.currentIndex < 0) state.currentIndex = 0;
    if (state.currentIndex > maxIndex) state.currentIndex = maxIndex;

    /* Pixel-perfect translateX — account for gap between slides */
    var offset = state.currentIndex * (slideWidth + gap);
    track.style.transform = 'translateX(-' + offset + 'px)';

    /* Update arrow disabled state */
    var wrapper = track.closest('.sub4-carousel-wrapper');
    if (wrapper) {
      var leftBtn  = wrapper.querySelector('.sub4-arrow--left');
      var rightBtn = wrapper.querySelector('.sub4-arrow--right');
      if (leftBtn)  leftBtn.disabled  = (state.currentIndex <= 0);
      if (rightBtn) rightBtn.disabled = (state.currentIndex >= maxIndex);
    }
  }

  window.sub4Prev = function (trackId) {
    var state = getState(trackId);
    state.currentIndex = Math.max(0, state.currentIndex - 1);
    updateCarousel(trackId);
  };

  window.sub4Next = function (trackId) {
    var track = document.getElementById(trackId);
    if (!track) return;
    var viewport = track.parentElement;
    if (!viewport) return;
    var slides = track.querySelectorAll('.sub4-slide');
    var total  = slides.length;
    var visible  = getVisibleCount(viewport.offsetWidth);
    var maxIndex = Math.max(0, total - visible);
    var state = getState(trackId);
    state.currentIndex = Math.min(maxIndex, state.currentIndex + 1);
    updateCarousel(trackId);
  };

  function initCarousels() {
    document.querySelectorAll('.sub4-carousel-track').forEach(function (track) {
      updateCarousel(track.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.sub4-carousel-track').forEach(function (track) {
        updateCarousel(track.id);
      });
    }, 120);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
